import { __makeTemplateObject, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { media } from '@elseu/sdu-titan';
import styled, { css } from 'styled-components';
import { createSlug } from '../../utilities/createSlug/createSlug.js';
import { StyledContent } from '../Content/Content.js';

/**
 * The styled component for the ContentSplit
 */
var StyledContentSplit = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    padding-bottom: ", ";\n\n    ", "\n\n    &:last-child {\n      padding-bottom: 0;\n    }\n\n    > .", " {\n      order: 0;\n      align-self: start;\n\n      ", "\n    }\n\n    > * {\n      flex: 1;\n      order: 1;\n\n      ", "\n    }\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    padding-bottom: ", ";\n\n    ", "\n\n    &:last-child {\n      padding-bottom: 0;\n    }\n\n    > .", " {\n      order: 0;\n      align-self: start;\n\n      ", "\n    }\n\n    > * {\n      flex: 1;\n      order: 1;\n\n      ", "\n    }\n  "])), theme.spacing[14], theme.spacing[14], media.greaterThan('s')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      flex-direction: row;\n    "], ["\n      flex-direction: row;\n    "]))), StyledContent.styledComponentId, media.greaterThan('s')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        order: initial;\n      "], ["\n        order: initial;\n      "]))), media.greaterThan('s')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        order: initial;\n      "], ["\n        order: initial;\n      "]))));
});
/**
 * The ContentSplit component
 *
 * @param {ContentSplitProps} props - The props for the ContentSplit component.
 * @returns {JSX.Element} The ContentSplit component.
 */
var ContentSplit = function (_a) {
  var children = _a.children,
    name = _a.name;
  return jsx(StyledContentSplit, __assign({
    "data-include-in-navigation": !!name
  }, name ? {
    id: createSlug(name)
  } : {}, {
    children: children
  }));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

export { ContentSplit, StyledContentSplit };
//# sourceMappingURL=ContentSplit.js.map
